import parseObjects from './parseObjects'

export default {
  after: {
    all: [
      parseObjects,
    ],
  },
}
